import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { installStaleChunkReload } from './utils/staleChunkReload';

/**
 * Vite SPA entry. Mounts <App /> under the #root div in index.html.
 * `StrictMode` is mandatory — React 19 keeps invariants stricter and
 * the admin is too small for legacy double-effects to bite.
 */
installStaleChunkReload(
  window,
  () => window.sessionStorage,
  () => window.location.reload(),
);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Admin root container not found — check index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
